import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconExternalOutlined = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M20 3.001c0-.54.44-1 1-1h7.92c.28-.02.56.08.78.3.18.18.3.44.3.7v8c0 .56-.44 1-1 1s-1-.44-1-1v-5.58l-12.3 12.3c-.4.4-1.02.4-1.42 0a.99.99 0 0 1 0-1.42l12.3-12.3H21c-.56 0-1-.44-1-1" clipRule="evenodd" /><path fill="currentColor" d="M30 17.001v11c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2v-24c0-1.1.9-2 2-2h11c.56 0 1 .44 1 1s-.44 1-1 1H4v24h24v-11c0-.56.44-1 1-1s1 .44 1 1" /></svg>;
export default SvgIconExternalOutlined;